export const encode = (inputString: string) => {
  try {
    const utf8Bytes = new TextEncoder().encode(inputString)
    const binaryString = Array.from(utf8Bytes)
      .map((byte) => String.fromCharCode(byte))
      .join('')
    const base64 = window.btoa(binaryString)
    return window.btoa(window.btoa(window.btoa(base64)))
  } catch (error) {
    console.error('Encoding error:', error)
    return window.btoa(window.btoa(window.btoa(window.btoa(inputString))))
  }
}
